import { DateTime } from "luxon";
import { useSelector } from "../../../app/helpers";
import { RootState } from "../../../app/rootReducer";
import { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";
import useTimezone from "../../../hooks/useTimezone/useTimezone";
import { isScheduleTimeLockedByConferenceServiceSetup } from "../functions/isScheduleTimeLockedByConferenceServiceSetup.function";

/**
 * Conference setup window: same flag for hiding cancel booking and blocking inline time edits.
 */
export function useConferenceServiceSetupLock(
  schedule: BookingScheduleInterface | undefined
): boolean {
  const {
    settings: { timezone: timezoneState }
  } = useSelector((state: RootState) => state.login);

  const deviceTimezone = useTimezone();

  if (!schedule) {
    return false;
  }

  const timezone = timezoneState === schedule.timezone ? schedule.timezone : deviceTimezone;

  return isScheduleTimeLockedByConferenceServiceSetup({
    schedule,
    timezone,
    now: DateTime.now()
  });
}
